import styled from 'styled-components'
import CardTitle from '../../../../common/styles/CardTitle'
import DateLineChart from '../DateLineChart'
import DateLineChartLoading from '../DateLineChartLoading'
import useBookStatisticsReadTime from '../hooks/useBookStatisticsReadTime'
import useScreenSize from '../../../../common/hooks/useScreenSize'
import NoContent from '../../../../common/NoContent'

const BookStatisticsReadTimeCard = () => {
	const [readTimeList, isLoading] = useBookStatisticsReadTime(30)

	const size = useScreenSize()
	const smallSize = 14
	const bigSize = 30

	return (
		<Container>
			<CardTitle icon={null} mb={0} textSize={5} title={`최근 ${size == 'sm' || size == 'xs' || size == 'md' ? 7 : 30}일 독서시간`} url={''} />

			<ChartWrapper>
				{!isLoading && readTimeList.length === 0 ? <NoContentCenter><NoContent message={'독서시간을 불러올 수 없어요'} /></NoContentCenter> : size == 'sm' || size == 'xs' || size == 'md' ? isLoading ? <DateLineChartLoading startDate={new Date().setDate(new Date().getDate() - smallSize + 1)} duration={smallSize} /> : <DateLineChart startDate={new Date().setDate(new Date().getDate() - smallSize + 1)} data={readTimeList.slice(30 - smallSize)} /> : isLoading ? <DateLineChartLoading startDate={new Date().setDate(new Date().getDate() - bigSize + 1)} duration={bigSize} /> : <DateLineChart startDate={new Date().setDate(new Date().getDate() - bigSize + 1)} data={readTimeList} />}
			</ChartWrapper>
		</Container>
	)
}

const Container = styled.div`
	height: 100%;
	background-color: var(--card-bg-color);
	border-radius: 16px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
	padding: 25px;
	display: flex;
	flex-direction: column;
`

const ChartWrapper = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
`

const NoContentCenter = styled.div`
	width: 100%;
	height: 350px;
	display: flex;
	align-items: center;
	justify-content: center;
`

export default BookStatisticsReadTimeCard
